import { render, staticRenderFns } from "./WarehouseStockOrders.vue?vue&type=template&id=f77a95e2&"
import script from "./WarehouseStockOrders.vue?vue&type=script&lang=js&"
export * from "./WarehouseStockOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports